import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import {
  getBenificiarys,
  deleteBenificiary,
  getNextBenificiarys,
  getPreviousBenificiarys,
} from "../../store/actions/benificiarys_action";
import { LIMIT } from "../../domain/constant";
import Pagination from "../../components/common/Pagination";
import Filters from "../../components/common/Filters";
import AddBtn from "../../components/common/AddBtn";
import {
  SEARCH_TERMS,
  view_all_table,
} from "../../shared/enums/benificiarys_enum";
import DataTable from "../../components/common/DataTable";
const AllBenificiarys = ({
  getBenificiarys,
  deleteBenificiary,
  getNextBenificiarys,
  getPreviousBenificiarys,
  benificiary: { loading, benificiarys },
}) => {
  const [page, setPage] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
  const [q, setQ] = useState(null);
  const [term, setTerm] = useState(null);
  const [termField, setTermField] = useState(SEARCH_TERMS[0]);
  useEffect(() => {
    async function allQuery() {
      if (deleteEntry) {
        await deleteBenificiary(deleteEntry);
      }
      getBenificiarys({});
    }
    allQuery();
  }, [deleteEntry]);

  const nextButtonClicked = () => {
    if (benificiarys && benificiarys.length === LIMIT) {
      const lastBenificiary = benificiarys[benificiarys.length - 1];
      getNextBenificiarys({ last: lastBenificiary });
      setPage(page + 1);
    }
  };
  const prevBtnClicked = () => {
    if (page > 1) {
      const lastBenificiary = benificiarys[0];
      getPreviousBenificiarys({
        first: lastBenificiary,
      });
      setPage(page - 1);
    }
  };
  const filterClicked = () => {
    if (term && term.length > 0) {
      setPage(1);
      setQ(term);
      getBenificiarys({ term: term, termField: termField });
    }
  };
  const deleteBenificiaryClicked = (id) => {
    setDeleteEntry(id);
  };
  const resetFilter = () => {
    setPage(1);
    setQ(null);
    setTerm("");
    getBenificiarys({});
  };

  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Benificiarys"
          mainLinkTitle="Dashboard"
          mainLinkUrl="/dashboard"
          activeLink="Benificiary"
        />

        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="card"
                style={{ boxShadow: "rgb(227 233 243) 0px 4px 22px" }}
              >
                <div className="card-body">
                  <AddBtn item="benificiarys" title="Benificiary" />
                  <hr />

                  <Filters
                    q={q}
                    resetFilter={resetFilter}
                    setTerm={setTerm}
                    term={term}
                    filterClicked={filterClicked}
                    termField={termField}
                    setTermField={setTermField}
                    all_terms={SEARCH_TERMS}
                  />
                  <hr />
                  <div>
                    <DataTable
                      keys={view_all_table}
                      data={benificiarys}
                      field={"benificiarys"}
                      page={page}
                      deleteBtnClicked={deleteBenificiaryClicked}
                      loading={loading}
                    />
                    <Pagination
                      data={benificiarys}
                      page={page}
                      prevBtnClicked={prevBtnClicked}
                      nextButtonClicked={nextButtonClicked}
                      loading={loading}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ benificiary: state.benificiary });

const mapDispatchToProps = {
  getBenificiarys,
  deleteBenificiary,
  getNextBenificiarys,
  getPreviousBenificiarys,
};

export default connect(mapStateToProps, mapDispatchToProps)(AllBenificiarys);
